import React, { useEffect, useState } from "react"
import axios from "axios"
import { dbURLAnyDayPeopleWTD, dbURLAllAnyDayPeopleWTD, customStylesSmall } from '../Constants';
import ReadMoreAndLess from "react-read-more-less";
import ReactPlayer from "react-player";
import ReactMarkdown from 'react-markdown';
import { Mobile, SelectProperty, SearchLists, calculateAge, calculateAgeAtDeath } from "../misc/utils";
import { animateScroll as scroll } from "react-scroll";
import Select from 'react-select';
import {DebounceInput} from 'react-debounce-input';

const isAdmin = localStorage.getItem("adminModeEgil") === "true";

const AnyDayPeople = (props) => {
    const [people, setPeople] = useState([])
    const [Allpeople, setAllPeople] = useState([])
    const [loadingPeople, setLoadingPeople] = useState(true)
    const [optionCat, SetOptionCat] = useState(null)

    const [error, setError] = useState(null)
    const [errorAllPeople, setErrorAllPeople] = useState(null)
    const [searchString, setSearchString] = useState('')

    const [showDeathModal, setShowDeathModal] = useState(false);
    const [deathModalContent, setDeathModalContent] = useState(""); 

   
    useEffect(() => {
      const fetchPeople = () => {
        axios.get(dbURLAnyDayPeopleWTD + props.dateSelected)
        .then(response => {
          setLoadingPeople(false)
          setPeople(response.data)
        }).catch(error => {
          setError(error);
        });
      }

      const fetchAllPeople = () => {
        axios.get(dbURLAllAnyDayPeopleWTD)
        .then(response => {
          //setLoadingAllPeople(false)
          setAllPeople(response.data)
        }).catch(errorAllPeople => {
            setErrorAllPeople(errorAllPeople);
        });
      }

      fetchPeople()
      fetchAllPeople()
    }, [props.dateSelected])

    if (error) return `Error: ${error.message}`;
    if (errorAllPeople) return `Error all people: ${errorAllPeople.message}`;

    const isMobile = Mobile();

    if (loadingPeople) {
        return <div>
                <main className="my-4 py-4"><div className="container"> 
                <div className="row pt-5"><div className="col">
                <h4>Loading...</h4></div></div></div></main>;
            </div>
    }

    let CatOptions, filterArray
    
    const scrollToBottom = () => {
        scroll.scrollToBottom();
        };

    //fjerne duplikater
    const peopleUnique  = people.filter(
        (obj, index) =>
        people.findIndex((item) => item.id === obj.id) === index
    );

    
    CatOptions = SelectProperty(Allpeople, 'cat')
    
    const SelectedOptionCat = (selectedCat) => {
        SetOptionCat(selectedCat);
    }

    const handleSearchChange = (e) => {
        setSearchString(e.target.value);
      };
    
    const clearSearchField = (e) => {
        setSearchString('')
        }

    if (searchString) {
        filterArray = SearchLists(Allpeople, 'searchname', searchString.toLowerCase());
        } 
    if (optionCat) {
        filterArray = Allpeople.filter(e => e.cat === optionCat.value);
        } 
    if (!optionCat && !searchString) {
        filterArray = peopleUnique;
        } 
    
    //funksjon for å sjekke om noen mangler dead_date
    const checkIfDead = async () => {
        console.log("🔍 Checking who might have passed away...");
        
        try {
            const peopleWithoutDeath = peopleUnique.filter(p => !p.dead);
            console.log("People without death:", peopleWithoutDeath);
            
            const checkingNames = peopleWithoutDeath.map(p => `🔎 Checking: ${p.name}`);

            const updatedPeople = await Promise.all(
            peopleWithoutDeath.map(async (person) => {
                console.log(`🔎 Checking: ${person.name}`);
                const response = await axios.get(`https://api2204.musicthisday.com/api/check-death/${encodeURIComponent(person.name)}`);
                console.log(`Response for ${person.name}:`, response.data);
            
                if (response.data.dead === true && response.data.date) {
                return {
                    ...person,
                    dead: response.data.date
                    //wiki: response.data.wiki || null
                };
                }
                return null;
            })
            );
            

            const deceased = updatedPeople.filter(p => p !== null);
        
            // Format modal content
            let content = `<h5 class="mb-3">People without death: ${peopleWithoutDeath.length}</h5>`;
            content += `<div class="text-start"><strong>${checkingNames.join("<br>")}</strong><br><br>`;
            
            if (deceased.length === 0) {
            content += `✅ No one has passed away 🎉</div>`;
            } else {
            content += `🕊 <b>${deceased.length} person(s)</b> found deceased:<br><br>`;
            deceased.forEach(p => {
                content += `<b>${p.name}</b> (${p.dead})<br><a href="${p.wiki}" target="_blank">${p.wiki}</a><br><br>`;
            });
            content += `</div>`;
            }
        
            setDeathModalContent(content);
            setShowDeathModal(true);
        
        } catch (err) {
            console.error('❌ Error checking death status:', err);
            setDeathModalContent('<div class="text-danger">Something went wrong while checking.</div>');
            setShowDeathModal(true);
        }
        };

    const WisePeople = filterArray.map(value => {

        let DescCharLimit, born, age, deadAge

        if (!value.dead) {
           age = calculateAge(value.birth_date)
        } 

        if (value.dead) {
            deadAge = calculateAgeAtDeath(value.birth_date, value.dead)
        }

        if (value.born) {
            born = value.born;
        }
        else {
            born = value.bd_text;
        }

        if (value.charlimit_description) {
            DescCharLimit = value.charlimit_description
        }
        
        if ((value.main_comment || value.comment) && (value.youtube_song ||value.youtube1) && !value.charlimit_description) {
            DescCharLimit = 500;
        }
        else if (!(value.main_comment || value.comment) && (value.youtube_song ||value.youtube1) && !value.charlimit_description) {
            DescCharLimit = 800;
        }
        else if ((value.main_comment || value.comment) && !(value.youtube_song ||value.youtube1) && !value.charlimit_description) {
            DescCharLimit = 900;
        }
        else if (!(value.main_comment || value.comment) && !(value.youtube_song ||value.youtube1) && !value.charlimit_description) {
            DescCharLimit = 1200;
        }

         // Function to copy person details to clipboard
        const handleCopy = async (person) => {

            const ageCopy = person.dead ? null : calculateAge(person.birth_date);

            const textToCopy = `${ageCopy ? `🎉 Happy ${ageCopy} Birthday, ${person.aka || person.name}!\n-> ` 
            : `🕊 Remembering ${person.aka || person.name}\n${person.born.replace(/\s+/g, " ")} - ${person.dead.replace(/\s+/g, " ")}\n-> https://www.wisdomthisday.com/`}
        \n${person.description}`;


                try {
                await navigator.clipboard.writeText(textToCopy);
                alert(`Copied to clipboard:\n\n${textToCopy}`);
                } catch (err) {
                console.error("Failed to copy:", err);
                }
            };

        return (

            <div key={value.id}>

                <div className="row">
                    <div className="col">
                        <div className="card shadow-sm mb-4">
                            <div className="card-body bg-light">
                                {value.aka &&
                                    <h5 className="card-title AnyDayName rounded py-2 ps-2">{value.aka}</h5>
                                }
                                {!value.aka &&
                                    <h5 className="card-title AnyDayName rounded py-2 ps-2">{value.name}</h5>
                                }
                                <div className="card-text">
                                    <div className="row">
                        
                                        {/* kolonne 1 */}
                                        {/* Only render image column if image exists */}
                                        {value.picture ? (
                                        <div className="col-sm-3">
                                            
                                                {isMobile &&
                                                    <div className='Text18 badge bg-secondary text-wrap rounded ms-2 mb-2'>
                                                            <div>{value.cat}</div>
                                                    </div>
                                                }
                                                
                                                <div align="center">
                                                    <div className="mb-1 rounded"><img src={value.picture} className="img-fluid rounded" alt="">
                                                        </img></div>
                                                        {isMobile && value.picture_link_text &&
                                                            <div className="Text11 mt-1">{value.picture_link_text}</div>
                                                        }
                                                        {!isMobile && value.picture_link_text &&
                                                            <div className="text-center Text13 mt-1">{value.picture_link_text}</div>
                                                        }
                                                    {value.selected_pic &&
                                                        <div className="rounded"><img src={value.selected_pic} className="img-fluid rounded" alt="">
                                                        </img></div>
                                                    }
                                                </div>

                                                {value.era &&
                                                    <div className="Text13 bg-light rounded mt-2 py-2 ps-3">

                                                        <div><b>Era: </b>{value.era}</div>

                                                        
                                                        {value.region &&
                                                        <div>
                                                            <b>Region: </b>{value.region}
                                                        </div>
                                                        }
                                                        
                                                        {value.movement &&
                                                        <div>
                                                            <b>Movement: </b>{value.movement}
                                                        </div>
                                                        }
                                                        
                                                    </div>
                                                }

                                                {value.school &&
                                                <div className="my-3 ms-2 p-2 Text13 bg-info rounded">
                                                        <div><b>School: </b>{value.school}</div>
                                                </div>
                                                }

                                        </div>
                                        ) : null}

                                        {/* kolonne 2 */}
                                        {/* Adjust column based on image presence */}
                                        <div
                                            className={
                                                value.picture
                                                ? value.youtube_song
                                                    ? "col-sm-4"
                                                    : "col-sm-5"
                                                : "col-sm-7"
                                            }
                                            >
                                            
                                            {!isMobile &&
                                            <div>
                                                <button type="button" className="btn btn-secondary btn-xs">
                                                <strong>{value.cat}</strong></button>
                                            </div>
                                            }
   
                                            <div className="Description py-1">
                                                
                                                <ReadMoreAndLess
                                                        charLimit={DescCharLimit}
                                                        readMoreText={" Read more ▼"}
                                                        readLessText={" Read less ▲"}
                                                        readMoreClassName="read-more-less--more"
                                                        readLessClassName="read-more-less--less"
                                                    >
                                                    {value.description}
                                                </ReadMoreAndLess>
                                                <div className="Description my-1"> 
                                                    <em> -> <a href={value.wiki}>wikipedia..</a></em>
                                                </div>
                                                
                                            </div>
                                        
                                            {value.main_comment &&
                                                <div className="card bg-light px-1 pt-2 mb-2">
                                                    <p className="quote13">{value.main_comment}</p> 
                                                    <div className="blockquote-footer"><i>{value.main_comment_source}</i></div>
                                                </div>
                                            }

                                            {value.quote2 && value.main_comment &&
                                                <div>
                                                    <div className="PeopleHeader2 py-1 px-1 mt-3 mb-2 rounded"><b>Selected quote</b></div>
                                                    <div className="card bg-light mb-3 px-1 py-1">
                                                        <div className="quote13">{value.quote2}</div> 
                                                        {value.source2 &&
                                                        <div className="blockquote-footer mt-1 quote12"><i>{value.source2}</i></div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            
                                            {value.comment &&
                                                <div className="row pt-3">
                                                        <div className="col-12">
                                                            {!value.source_details &&
                                                                <div className="card bg-light px-1 pt-2 mb-2">
                                                                    <p className="quote13">{value.comment}</p> 
                                                                    <div className="blockquote-footer"><i>{value.source}</i></div>
                                                                </div>
                                                            }
                                                            {value.source_details &&
                                                                <div className="card bg-light px-1 pt-2 mb-2">
                                                                    <p className="quote13">{value.comment}</p> 
                                                                    <div className="blockquote-footer"><i>{value.source} ({value.source_details})</i></div>
                                                                </div>
                                                            }
                                                    </div>
                                                </div>
                                            }

                                            {isAdmin  &&
                                                <div className="mt-4">DescCharLimit: {DescCharLimit}</div>
                                            }
                                            

                                        </div>
                        
                                        {/* kolonne 3 */}
                                        {/* Adjust column based on image presence */}
                                        <div
                                            className={
                                                value.picture
                                                ? value.youtube_song
                                                    ? "col-sm-3"
                                                    : "col-sm-4"
                                                : "col-sm-5"
                                            }
                                            >

                                                <div className="row">

                                                    <div className="col-12">
                                                        <b>Born </b><br />

                                                        {age && value.born_place && props.dateSelected === value.born_slug &&
                                                            <div className="Date mb-2 p-1 rounded"><b>{born}</b> (age {age}) <br /> {value.born_place}</div>
                                                        }
                                                        {!age && value.born_place && props.dateSelected === value.born_slug &&
                                                            <div className="Date mb-2 p-1 rounded"><b>{born}</b> - {value.born_place}</div>
                                                        }

                                                        {value.born_place && !(props.dateSelected === value.born_slug) &&
                                                            <div className="Date mb-2 p-1 rounded">{born} - {value.born_place}</div>
                                                        }

                                                        {!value.born_place && props.dateSelected === value.born_slug &&
                                                            <div className="Date mb-2 p-1 rounded"><b>{born}</b> (age {age})</div>
                                                        }

                                                        {age && !value.born_place && !(props.dateSelected === value.born_slug) &&
                                                            <div className="Date mb-2 p-1 rounded">{born} (age {age})</div>
                                                        }
                                                        {!age && !value.born_place && !(props.dateSelected === value.born_slug) &&
                                                            <div className="Date mb-2 p-1 rounded">{born}</div>
                                                        }
                                                        

                                                        {value.dead_place && value.dead && (props.dateSelected === value.dead_slug) &&
                                                            <div>
                                                                <b>Dead </b><br />
                                                                <div className="Date mb-2 p-1 rounded">
                                                                    <b>{value.dead}</b> 
                                                                    {!value.dead_place?.includes('(aged') && ` (aged ${deadAge})`} - {value.dead_place}
                                                                </div> 
                                                            </div>
                                                        }

                                                        {value.dead_place && value.dead && !(props.dateSelected === value.dead_slug) &&
                                                            <div>
                                                                <b>Dead </b><br />
                                                                <div className="Date mb-2 p-1 rounded">
                                                                    {value.dead} 
                                                                    {!value.dead_place?.includes('(aged') && ` (aged ${deadAge})`} - {value.dead_place}
                                                                </div> 
                                                            </div>
                                                        }

                                                        {!value.dead_place && value.dead && (props.dateSelected === value.dead_slug) &&
                                                            <div>
                                                                <b>Dead </b><br />
                                                                <div className="Date mb-2 p-1 rounded"><b>{value.dead}</b> (aged {deadAge})
                                                                </div> 
                                                            </div>
                                                        }

                                                        {!value.dead_place && value.dead && !(props.dateSelected === value.dead_slug) &&
                                                            <div>
                                                                <b>Dead </b><br />
                                                                <div className="Date mb-2 p-1 rounded">{value.dead} (aged {deadAge})
                                                                </div> 
                                                            </div>
                                                        }

                                                        {value.resting_place &&
                                                            <div>
                                                                <b>Resting place </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.resting_place}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.nationality &&
                                                            <div>
                                                                <b>Nationality </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.nationality}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.occupation &&
                                                            <div>
                                                                <b>Occupation </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.occupation}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.education &&
                                                            <div>
                                                                <b>Education / Alma mater </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.education}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.known_for &&
                                                            <div>
                                                                <b>Known for  </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.known_for}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.sub_genres && (value.cat !== 'Music') &&
                                                            <div>
                                                                <b>Fields </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.sub_genres}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.movement && !value.era &&
                                                            <div>
                                                                <b>Movement </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.movement}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.notable_work &&
                                                            <div>
                                                                <b>Notable work </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.notable_work}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.fields &&
                                                            <div>
                                                                <b>Fields  </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.fields}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.main_interests &&
                                                            <div>
                                                                <b>Main interests  </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.main_interests}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {value.notable_ideas &&
                                                            <div>
                                                                <b>Notable ideas  </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.notable_ideas}</div>
                                                                </div>
                                                            </div>
                                                        }       

                                                        {value.awards &&
                                                                <div>
                                                                    <b>Notable awards</b> <br />
                                                                    <div className="factTextNoWrap p-1 rounded"> 
                                                                        <ReactMarkdown>
                                                                            {value.awards}                    
                                                                        </ReactMarkdown> 
                                                                    </div>
                                                                </div>
                                                        }

                                                        {value.sub_genres && value.main_genre &&
                                                            <div>
                                                                <b>Genres </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.main_genre}, {value.sub_genres}</div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {!value.sub_genres && value.main_genre &&
                                                            <div>
                                                                <b>Genres </b><br />
                                                                <div>
                                                                    <div className="factText mb-2 p-1 rounded">{value.main_genre}</div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {
                                                            (() => {
                                                                if (value.instrument) {
                                                                return   <div>
                                                                        <b>Instruments </b><br />
                                                                        <div>
                                                                            <div className="factText mb-2 p-1 rounded">{value.instrument}</div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                return
                                                            })()
                                                        }

                                                        {   
                                                            (() => {
                                                                if (value.associated_acts) {
                                                                return   <div>
                                                                        <b>Associated acts </b><br />
                                                                        <div>
                                                                            <div className="factText mb-2 p-1 rounded">{value.associated_acts}</div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                return
                                                            })()
                                                        }

                                                        {   
                                                            (() => {
                                                                if (value.years_active) {
                                                                return   <div>
                                                                        <b>Years active </b><br />
                                                                        <div>
                                                                            <div className="factText p-1 rounded">{value.years_active}</div>
                                                                        </div>  
                                                                    </div>
                                                                }
                                                                return
                                                            })()
                                                        }


                                                        {value.quote1 &&
                                                            <div>
                                                                <div className="PeopleHeader2 py-1 ps-2 mt-3 mb-2 rounded"><b>Selected quote</b></div>
                                                                <div className="card bg-light mb-3 px-2 py-1">
                                                                    <div className="quote13">{value.quote1}</div> 
                                                                    {value.source1 &&
                                                                    <div className="blockquote-footer mt-1 quote12"><i>{value.source1}</i></div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                        {value.quote2 && !value.main_comment &&
                                                            <div>
                                                                <div className="card bg-light mb-3 px-2 py-1">
                                                                    <div className="quote13">{value.quote2}</div> 
                                                                    {value.source2 &&
                                                                    <div className="blockquote-footer mt-1 quote12"><i>{value.source2}</i></div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        } 

                                                    </div>

                                                </div>  
                                            
                                        </div>

                                        {/* kolonne 4 - IF youtube*/}
                                        {value.youtube_song ? (
                                            <div className="col-sm-2">
                                                <div className="text-center">
                                                <div className="bg-light text-wrap rounded"><h5>Selected songs</h5></div>
                                                 {value.youtube_song &&
                                                    <div className="text-center mt-1">
                                                            <div className="border bg-light mt-1 rounded">
                                                                <ReactPlayer
                                                                url={ value.youtube_song }
                                                                light='true'
                                                                volume={0.9}
                                                                controls={true}
                                                                width="426"
                                                                height="240"
                                                                />
                                                            </div>
                                                            <div className='factText2 mt-1 rounded'>
                                                                <strong>{value.youtube_text}</strong>
                                                            </div>
                                                    </div>
                                                }
                                                {value.youtube1 &&
                                                    <div className="text-center mt-3">
                                                            <div className="border bg-light mt-1 rounded">
                                                                <ReactPlayer
                                                                url={ value.youtube1 }
                                                                light='true'
                                                                volume={0.9}
                                                                controls={true}
                                                                width="426"
                                                                height="240"
                                                                />
                                                            </div>
                                                            <div className='factText2 mt-1 rounded'>
                                                                <strong>{value.song1_txt}</strong>
                                                            </div>
                                                    </div>
                                                }
                                                 {value.youtube2 &&
                                                    <div className="text-center mt-3">
                                                            <div className="border bg-light mt-1 rounded">
                                                                <ReactPlayer
                                                                url={ value.youtube2 }
                                                                light='true'
                                                                volume={0.9}
                                                                controls={true}
                                                                width="426"
                                                                height="240"
                                                                />
                                                            </div>
                                                            <div className='factText2 mt-1 rounded'>
                                                                <strong>{value.song2_txt}</strong>
                                                            </div>
                                                    </div>
                                                }
                                                </div>
                                            </div>
                                        ) : null}
                            
                                    </div>

                                </div>
                                {isAdmin && (
                                    <button className="btn btn-primary btn-xxs float-start" onClick={() => handleCopy(value)}>
                                        Copy
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>



                   
            </div>
        )
    })

  return (
    <div>
      {peopleUnique.length < 1 && 
        <div>
            <h2>Sorry, no notable births or deaths recorded for this date in the database.</h2>
        </div>
      }
      {peopleUnique.length > 0 && 
        <div>
            <div className="row TodayTitle24nobg mx-5">
                <div className="col-sm-12"> 
                    <div className="text-center"><h2>Notable people</h2>
                    </div>
                    {isAdmin && (
                    <div>
                        <div className="card shadow-sm mb-3" style={{ maxWidth: '600px' }}>
                        <div className="card-body bg-light">
                      
                          {/* Check if anyone has passed */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0">Actions</h6>
                            <button className="btn btn-warning btn-sm" onClick={checkIfDead}>
                              Check if anyone has passed 🕊
                            </button>
                          </div>
                      
                          {/* Category Select + Reset */}
                          <div className="mb-3 row align-items-center">
                            <div className="col">
                              <Select
                                className="select"
                                value={optionCat}
                                onChange={SelectedOptionCat}
                                options={CatOptions}
                                placeholder="Select a category.."
                                styles={customStylesSmall}
                              />
                            </div>
                            <div className="col-auto">
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => SetOptionCat(null)}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                      
                          {/* Search + Reset */}
                          <div className="mb-2 row align-items-center">
                            <div className="col">
                              <DebounceInput
                                minLength={3}
                                debounceTimeout={500}
                                value={searchString}
                                onChange={handleSearchChange}
                                placeholder="Search all names"
                                className="form-control"
                              />
                            </div>
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={clearSearchField}
                              >
                                Reset search
                              </button>
                            </div>
                          </div>
                      
                        </div>
                      </div>
                    </div>
                    
                    )}
                </div>
            </div>

            {!isMobile &&
                <div className="row">
                    <div className="col pb-1 me-2 mb-2" align="Right"> 
                        <button type="button" className="btn btn-primary btn-sm" onClick={scrollToBottom}>
                        <b>Scroll down</b>
                        </button>
                    </div>
                </div>
            }
         
            {WisePeople}

            
       
        </div>
      }
      {showDeathModal && (
        <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title">Death Check Results</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowDeathModal(false)}></button>
                </div>
                <div className="modal-body">
                <div dangerouslySetInnerHTML={{ __html: deathModalContent }} />
                </div>
                <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeathModal(false)}>
                    Close
                </button>
                </div>
            </div>
            </div>
        </div>
        )}
    </div>
  )
}

export default AnyDayPeople
